interface UseVideoHandlerProps {
  builderMode?: boolean;
  videoUrl: string;
  videoMap?: Map<string, any>;
}

/**
 * Returns the best video source URL based on builderMode and videoMap.
 */
export const getVideoLocalSrc = ({ builderMode, videoUrl, videoMap }: UseVideoHandlerProps): string => {
  if (!builderMode && videoMap) {
    try {
      const videoData = videoMap.get(videoUrl);
      if (videoData?.localFile?.fields?.publicURL) {
        return videoData.localFile.fields.publicURL;
      }
    } catch (error) {
      console.error('Error processing video:', error);
    }
  }
  return videoUrl;
};
